/* eslint-disable @typescript-eslint/naming-convention */
import { useMemo } from 'react';
import { AGENTS } from '../constants/agents';
export function useAgentTheme(agentName) {
    return useMemo(() => {
        const agent = agentName ? AGENTS[agentName] : undefined;
        return {
            '--agent-color': (agent === null || agent === void 0 ? void 0 : agent.color) || '#585870',
            '--agent-icon': (agent === null || agent === void 0 ? void 0 : agent.icon) || 'fa-light fa-robot'
        };
    }, [agentName]);
}
